import { createFileRoute, redirect, useParams } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { BalancePage } from "../pages/BalancePage";
import { storage } from "../lib/storage";

const langMap: Record<string, string> = {
  oz: "uz-Latn",
  uz: "uz-Cyrl",
  ru: "ru",
  en: "en-US",
};

export const Route = createFileRoute("/$lang/balance")({
  beforeLoad: () => {
    if (typeof window !== "undefined" && !storage.getItem("auth_token")) {
      throw redirect({ to: "/" });
    }
  },
  component: Balance,
});

function Balance() {
  const { lang } = useParams({ from: "/$lang/balance" });
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = langMap[lang] || "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage(lang);
  }, [lang, i18n]);
  return (
    <LangProvider lang={langMap[lang] || "uz-Latn"}>
      <BalancePage />
    </LangProvider>
  );
}
